const SITE_URL = "https://raffielnias.com";

const upsert = (selector, create) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  return el;
};

export const applySeo = ({ title, description, path }) => {
  if (title) document.title = title;
  if (description) {
    upsert('meta[name="description"]', () => {
      const m = document.createElement("meta");
      m.name = "description";
      return m;
    }).setAttribute("content", description);
  }
  const url = SITE_URL + (path || "/");
  upsert('link[rel="canonical"]', () => {
    const l = document.createElement("link");
    l.rel = "canonical";
    return l;
  }).setAttribute("href", url);
  const og = (prop, val) => {
    if (!val) return;
    upsert(`meta[property="${prop}"]`, () => {
      const m = document.createElement("meta");
      m.setAttribute("property", prop);
      return m;
    }).setAttribute("content", val);
  };
  og("og:title", title);
  og("og:description", description);
  og("og:url", url);
};

export const ROUTE_SEO = {
  "/": {
    title: "Raffiel Nias — Surf Hotel at Sorake Beach, Lagundri Bay",
    description:
      "Beachfront surf hotel at Sorake Beach, Lagundri Bay, Nias. Rooms from $45/night, pool, rooftop café, surf lessons & board transfer from Medan & Padang.",
    path: "/",
  },
  "/board-transfer": {
    title: "Board Bag Transfer Medan & Padang to Nias | Raffiel Nias Surf Hotel",
    description:
      "Skip airline surfboard fees: board bag shipment from Medan KNO (IDR 1,300,000) and Padang PDG (IDR 1,600,000) delivered to Raffiel Nias, Sorake Beach.",
    path: "/board-transfer",
  },
  "/blog": {
    title: "Surf Guide & Blog — Raffiel Nias Surf Hotel, Sorake Beach",
    description:
      "Local knowledge from Lagundri Bay: swell seasons, board logistics, where to eat and how to plan the perfect surf trip to South Nias.",
    path: "/blog",
  },
  "/rooms": {
    title: "Rooms & Ocean View Apartments from $45 — Raffiel Nias, Sorake Beach",
    description:
      "Standard rooms from $45, Ocean View Deluxe from $60, Two Bedroom Apartment from $130. Beachfront at Sorake Beach, Lagundri Bay with monthly stays from $700.",
    path: "/rooms",
  },
  "/surf-lessons": {
    title: "Surf Lessons, Photography & Airport Transfers — Raffiel Nias",
    description:
      "Surf lessons at Lagundri Bay, daily surf photography and Binaka airport transfers — full surf services at Raffiel Nias, Sorake Beach, South Nias.",
    path: "/surf-lessons",
  },
  "/guide": {
    title: "Sorake & Lagundri Bay Surf Guide — Raffiel Nias, South Nias",
    description:
      "The complete guide to surfing Sorake Beach and Lagundri Bay: the wave, seasons, getting there via Medan or Padang, where to stay and eat.",
    path: "/guide",
  },
  "/admin": {
    title: "Admin — Raffiel Nias",
    description: "Raffiel Nias admin.",
    path: "/admin",
  },
};
